// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3fG-v","signatureButtonsRight":"ModalSign_signatureButtonsRight__2dd1R"};